import Vue from 'vue';
import productTransformer from './../../transformers/product';

const success = (resolve, data) => {
  resolve(productTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.errors) {
    reject(productTransformer.fetch(errors.errors));
  }
  reject(productTransformer.fetch(errors));
};
const getFormData = (formData, data, previousKey) => {
  if (data instanceof Object && !Array.isArray(data)) {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (value instanceof Object && !Array.isArray(value)) {
        return getFormData(formData, value, key);
      }
      if (previousKey) {
        key = `${previousKey}[${key}]`;
      }
      if (Array.isArray(value)) {
        value.forEach((val) => {
          formData.append(`${key}[]`, val);
          return null;
        });
      } else {
        formData.append(key, value);
      }
      return null;
    });
  } else if (data instanceof Object && Array.isArray(data)) {
    data.forEach((val, i) => {
      Object.keys(val).forEach((key) => {
        formData.append(`${previousKey}[${i}][${key}]`, val[key]);
        return null;
      });
      return null;
    });
  } else {
    formData.append(previousKey, data);
  }
};

export default (product) => {
  const data = new FormData();
  Object.keys(product).map((k) => {
    getFormData(data, product[k], k);
    return null;
  });
  return new Promise((resolve, reject) => {
    Vue.$http
      .request({
        url: 'products',
        data,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
        },
      })
      .then((response) => {
        success(resolve, response.data);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  });
};



// WEBPACK FOOTER //
// ./src/app/services/product/store.js